<template>
  <v-autocomplete
    prepend-icon="label"
    :items="items"
    :item-text="'nombre'"
    :item-value="'id'"
    v-model="item"
    :label="$t('producto.labels.modelo')"
    :loading="loading"
    :error="hasInputErrors('modelo')"
    :error-messages="getInputErrors('modelo')"
    color="secondary"
    item-color="secondary"
    :rules="isRequired ? required : []"
    :multiple="multiple"
    :chips="chips"
    :solo="solo"
    :disabled="disabled"
    :readonly="readonly"
    clearable
    :hide-details="hideDetails"
    :style="{ width: width, maxWidth: width }"
    :return-object="effectiveReturnObject"
  ></v-autocomplete>
</template>

<script>
import { InputErrorsByProps, RequiredRule } from "@dracul/common-frontend";

import ModeloProvider from "../../../../modelo/providers/ModeloProvider";

export default {
  name: "ModeloCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    // Puede recibir el id (String) o el objeto completo (Object) del modelo
    value: { type: [String, Array, Object] },
    multiple: { type: Boolean, default: false },
    solo: { type: Boolean, default: false },
    chips: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: false },
    itemValue: { type: String, default: "id" },
    width: { type: String, default: null },
    marca: Object,
  },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  computed: {
    effectiveReturnObject() {
      if (this.returnObject) return true;
      return this.value != null && typeof this.value === "object" && !Array.isArray(this.value);
    },
    item: {
      get() {
        return this.value;
      },
      set(val) {
        if (val === null || val === undefined || val === "") {
          this.$emit("input", null);
          return;
        }
        if (typeof val === "object") {
          this.$emit("input", val);
          return;
        }
        const foundItems = this.items.filter((item) => String(item.id) === String(val));
        if (foundItems.length > 0) {
          this.$emit("input", foundItems[0]);
        }
      },
    },
  },
  mounted() {
    // Si hay una marca en el prop, usarla para buscar modelos
    if (this.marca) {
      this.fetch(this.marca);
    }
    // Si no hay marca pero el value es un modelo con marca, usar esa marca
    else if (this.value && this.value.marca) {
      this.fetch(this.value.marca);
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    fetch(marca) {
      if (marca) {
        this.loading = true;
        ModeloProvider.fetchModelos(marca.id)
          .then((r) => {
            this.items = r.data.modeloFetch;
          })
          .catch((err) => console.error(err))
          .finally(() => (this.loading = false));
      }
    },
  },
  watch: {
    marca(value) {
      if (!value || !value.id) {
        this.items = [];
      }
      this.fetch(value);
    },
  },
};
</script>

<style scoped></style>
